import * as actions from '../actions';

const initialState = {};

let user = (state = initialState, { type, uid, email, subscription, loginProviderId, guestId }) => {
  switch (type) {
    case actions.SET_USER_INFO:
      // A real Firebase user is now signed in; clear any guest flag.
      return { ...state, uid, email, subscription, loginProviderId, isGuest: false };
    case actions.SET_GUEST_MODE:
      // No Firebase user present — run as an anonymous guest.
      return { ...state, uid: undefined, email: undefined, subscription: undefined, isGuest: true, guestId };
    default:
      return state;
  }
};

export default user;
